/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
} from '@devexpress/dx-react-grid-material-ui';
import { downloadCSVFile, getRowId } from '../../common';
import { getWorkReport } from '../../graphql';
import { useLazyQuery } from '@apollo/client';
import {
  currencyFormatterEmpty,
  sentShowFormatter,
  timeFormatter,
  userFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { getColumns } from '../../common/columns';
import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import useEmployees from '../../hooks/useEmployees';
import { useUsers } from '../../hooks';
import ExportBtn from '../../common/ExportBtn';
import AutoFieldLocal from '../../components/fields/AutoFieldLocal';
import { TableComponent } from '../components/TableComponent';
import HRContext from '../../contexts/hr';

const WorkReport = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end } = props;
  const [attendance, setAttendance] = useState(true);
  const [overtime, setOvertime] = useState(true);

  const col = getColumns({ isRTL, words });
  const [emplvalue, setEmplvalue] = useState<any>(null);

  const [columns, setColumns] = useState([]);

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 150 },
    { columnName: 'opDocNo', width: 120 },
    { columnName: col.employee.name, width: 200 },
    { columnName: 'isWorking', width: 100 },
    { columnName: 'isAbsent', width: 100 },
    { columnName: 'working', width: 100 },
    { columnName: 'absent', width: 100 },
    { columnName: 'overtime', width: 120 },
    { columnName: 'bonos', width: 120 },
    { columnName: 'deduction', width: 120 },
    { columnName: 'desc', width: 200 },
    { columnName: 'userId', width: 150 },
  ]);

  const [rows, setRows] = useState([]);

  const { activeemployees: employees } = useEmployees();
  const { users } = useUsers();

  const {
    state: { hiddenColumnNames },
    dispatch,
  } = useContext(HRContext);

  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };

  const [loadHritems, opData]: any = useLazyQuery(getWorkReport, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
      employeeId: emplvalue ? emplvalue?._id : undefined,
    };
    if (start && end) {
      loadHritems({
        variables,
      });
    }
  }, [start, end, emplvalue]);

  useEffect(() => {
    if (emplvalue) {
      setColumns([
        { name: 'time', title: words?.time },
        { name: 'opDocNo', title: words?.ref },
        col.employee,
        { name: 'isWorking', title: isRTL ? 'حاضر' : 'Present' },
        { name: 'isAbsent', title: isRTL ? 'غائب' : 'Absent' },
        { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
        { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
        { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
        { name: 'desc', title: words?.notes },
        col.userId,
      ]);
    } else {
      setColumns([
        col.employee,
        { name: 'working', title: isRTL ? 'حاضر' : 'Present' },
        { name: 'absent', title: isRTL ? 'غائب' : 'Absent' },
        { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
        { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
        { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
        col.userId,
      ]);
    }
  }, [emplvalue]);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));
  useEffect(() => {
    if (opData?.data?.getWorkReport?.data) {
      const { data } = opData.data.getWorkReport;
      let ndata = data;
      if (!attendance && !overtime) {
        setRows([]);
      } else {
        if (!attendance) {
          ndata = ndata.filter(
            (ndi: any) => ndi.bonos > 0 || ndi.overtime > 0 || ndi.deduction > 0
          );
        }
        if (!overtime) {
          ndata = ndata.filter(
            (ndi: any) => ndi.isWorking === true || ndi.isAbsent === true
          );
        }
        setRows(ndata);
      }
    }
  }, [opData, attendance, overtime]);

  const downloadCSVSubmit = () => {
    const colnames = columns?.map((col: any) => col?.name);
    downloadCSVFile(rows, 'Work Report', colnames);
  };

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          top: 8,
          left: isRTL ? 400 : undefined,
          right: isRTL ? undefined : 400,
          display: 'flex',
        }}
      >
        <ExportBtn open={downloadCSVSubmit} isRTL={isRTL}></ExportBtn>
      </Box>
      <Box
        display="flex"
        style={{
          position: 'absolute',
          top: 55,
          left: isRTL ? 400 : undefined,
          right: isRTL ? undefined : 400,
          display: 'flex',
          flexGrow: 1,
          zIndex: 111,
        }}
      >
        <Box display={'flex'}>
          <AutoFieldLocal
            name="employee"
            title={words?.employee}
            words={words}
            options={employees}
            value={emplvalue}
            setSelectValue={setEmplvalue}
            isRTL={isRTL}
            width={300}
            mb={0}
          ></AutoFieldLocal>
          {emplvalue && (
            <>
              <FormControlLabel
                style={{ marginLeft: 10, marginRight: 10 }}
                control={
                  <Checkbox
                    checked={attendance}
                    onChange={() => setAttendance(!attendance)}
                    name="bold"
                    color="primary"
                  />
                }
                label={isRTL ? 'الحضور' : 'Attendance'}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={overtime}
                    onChange={() => setOvertime(!overtime)}
                    name="bold"
                    color="primary"
                  />
                }
                label={isRTL ? 'المالي' : 'Finance'}
              />
            </>
          )}
        </Box>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <SearchState />
        <IntegratedSorting />
        <IntegratedFiltering />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 40 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            'time',
            'opDocNo',
            col.employee.name,
            'isWorking',
            'isAbsent',
            'working',
            'absent',
            'overtime',
            'bonos',
            'deduction',
            'desc',
            'userId',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['userId']}
          formatterComponent={(props: any) =>
            userFormatter({ ...props, users })
          }
        ></DataTypeProvider>
        <DataTypeProvider
          for={['isWorking', 'isAbsent']}
          formatterComponent={sentShowFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['overtime', 'bonos', 'deduction']}
          formatterComponent={currencyFormatterEmpty}
        ></DataTypeProvider>
        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
      </Grid>
    </>
  );
});

export default WorkReport;
